import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';

import { NumericStepper } from '../../TripDetails/NumericStepper';
import { serviceDetailsNameRoot } from './ServiceDetailsFormBody';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

export function NumberAttendantsContextField() {
  const fieldName = `${serviceDetailsNameRoot}.num_attendants_needed`;
  return (
    <FormFieldController name={fieldName}>
      {({ field, fieldState }) => {
        return (
          <DefaultFormFieldLayout
            label="Attendants Needed"
            error={fieldState.error?.message?.toString()}
            inputId={fieldName}
          >
            <NumericStepper
              {...field}
              onChange={(e: any) => {
                field.onChange(Number(e.target.value));
              }}
              min={0}
              max={4}
            />
          </DefaultFormFieldLayout>
        );
      }}
    </FormFieldController>
  );
}
